import React, { Component } from 'react';
import { Button } from 'antd';
import CanvasDraw from '@components/Canvas';
import { CloseCircleFilled } from "@ant-design/icons";
import './index.less';

import { connect } from 'react-redux';
import Type from "@actionTypes";

class Signature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brushRadius: 5,
            lazyRadius: 12,
            width: document.body.clientWidth - 40
        };
        this.timeout = {}
        sessionStorage.setItem('token', this.getQueryVariable('token'))
        props.dispatch({
            type: Type.LOGIN_SUCCESS,
            token: this.getQueryVariable('token')
        })
        let startY, endY;
        document.body.addEventListener('touchstart', function(e) {
            startY = e.touches[0].pageY;
        });
        document.body.addEventListener('touchmove', function(e) {
            endY = e.touches[0].pageY;
            // 手指下滑，页面到达顶端不能继续下滑
            if (endY > startY && document.body.scrollTop <= 0) {
                e.preventDefault();
            }
        }, {passive: false});
    }
    mouseDown = () => {
        clearTimeout(this.timeout);
    };
    mouseUp = () => {
        this.timeout = setTimeout(this.onSave, 3000)
    };
    onSave = () => {
        const savedDrawing = [];
        localStorage.getItem("savedDrawing") && savedDrawing.push(localStorage.getItem("savedDrawing"))
        savedDrawing.push(this.saveableCanvas.getSaveData())
        localStorage.setItem(
            "savedDrawing",
            savedDrawing.toString()
        );
        this.reload();
        this.saveableCanvas.clear();
    };
    clear = () => {
        this.loadableCanvas.clear();
        localStorage.setItem('savedDrawing', [])
    };
    reload = () => {
        this.loadableCanvas.loadSaveData(
            localStorage.getItem("savedDrawing")
        );
    };
    upload = () => {
        const src = document.getElementById('canvasViewdrawing').toDataURL();
        document.getElementById('canvasImg').src=src
        this.props.dispatch({
            type: Type.POST_CANVAS,
            src
        });
        // console.log(document.getElementById('canvasView')) ;
    };
    getQueryVariable = (variable) => {
        const query = window.location.search.substring(1);
        const vars = query.split("&");
        for (let i=0;i<vars.length;i++) {
            const pair = vars[i].split("=");
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return(false);
    };
    render() {
        return (
            <div className="signature" >
                {/*<div className="title">电子签名</div>*/}
                <div className="signature-content">
                    <div>
                        <p className="write-title">请在下方范围内输入您的签名</p>
                        <div className="write-pane" onTouchStart={this.mouseDown} onTouchEnd={this.mouseUp}>

                            <CanvasDraw
                                id="write"
                                // onmouseup={this.mouseUp}
                                // onmousedown={this.mouseDown}
                                ref={canvasDraw => (this.saveableCanvas = canvasDraw)}
                                brushRadius={this.state.brushRadius}
                                lazyRadius={this.state.lazyRadius}
                                canvasWidth={this.state.width}
                                canvasHeight={this.state.width}
                            />
                        </div>
                    </div>
                    <div />
                    <div>
                        <p className="write-title">签名预览：</p>
                        <div className="signature-view" >
                            <CanvasDraw
                                id="canvasView"
                                disabled
                                canvasWidth={this.state.width - 2}
                                canvasHeight={72}
                                ref={canvasDraw => (this.loadableCanvas = canvasDraw)}
                                saveData={localStorage.getItem("savedDrawing")}
                            />
                            <CloseCircleFilled className="clear" style={{ fontSize: 20, color: '#BBBBBB' }} onClick={this.clear} />
                            {/* <Icon className="clear" style={{ fontSize: 20, color: '#BBBBBB' }} onClick={this.clear} type="close-circle" theme="filled" /> */}
                            <img style={{ display: 'none' }} id="canvasImg" src="" alt="生成的图片" width="100%" height="100%" />
                        </div>
                    </div>
                    <div className="signature-foot">
                        <Button className="signature-btn" type='primary' onClick={this.upload}>上传</Button>
                    </div>

                </div>
            </div>
        )
    }
}


const getState = state => {
    return {
        ...state,
    }
}
export default connect(getState)(Signature)
